module.exports = __webpack_public_path__ + "static/assets/065850c834b3fe3820976c388bebd31d.svg";